import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../../api/api";
import { CircularProgress, Box } from "@mui/material";

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("token");
    const isCurrentSession = () => active && token === localStorage.getItem("token");
    const rejectToken = () => {
      localStorage.removeItem("token");
      delete api.defaults.headers.common.Authorization;
    };
    const checkAuth = async () => {
      try {
        if (!token) {
          setIsAuthenticated(false);
          return;
        }
        const response = await api.get("/login/verify-token", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!isCurrentSession()) return;
        const valid = response.status === 200 && response.data?.valid === true;
        setIsAuthenticated(valid);
        if (!valid) rejectToken();
      } catch (error) {
        if (!isCurrentSession()) return;
        console.error("Ошибка проверки авторизации:", error);
        setIsAuthenticated(false);
        if (error.response?.status === 401 || error.response?.status === 403) rejectToken();
      } finally {
        if (active) setIsLoading(false);
      }
    };
    checkAuth();
    return () => { active = false; };
  }, []);

  // Показываем загрузку
  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: '#243747',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress 
          size={36}
          thickness={3}
          aria-label="Загрузка страницы"
          sx={{ 
            color: '#8fa6bb',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round'
            }
          }} 
        />
      </Box>
    );
  }

  // Если не авторизован, перенаправляем на страницу ошибки
  if (!isAuthenticated) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  // Если авторизован, показываем контент
  return children;
}

export default ProtectedRoute;
